import React, { useEffect, useContext } from 'react';
import { ProductContext } from '../../ProductContext';
import { StoreLocatorAction } from '../StoreLocator/StoreLocatorAction';
import { openStoreLocatorSidebar, storeLocatorSidebarState } from '../StoreLocator/storeLocatorSidebarState';
import { customerLocationState } from '../StoreLocator/customerLocationState';
import { observer } from 'mobx-react-lite';
import { sddState } from './sddState';
import { SiteSettings } from 'src/scripts/utils/environment';
import { reaction } from 'mobx';
import './style.scss';
import SddOmniPdpMessagingView from './SddOmniPdpMessagingView';
import { StoreLocatorSidebarPdpData } from '../StoreLocator/storeLocatorTypes';

let SddMessaging = ({ shouldShowOmniPdpExperience = false }: { shouldShowOmniPdpExperience?: boolean }) => {
  const { sidebarPdpData } = useContext(ProductContext);
  const selectedVariant = sidebarPdpData?.selectedVariant;
  const sddData = sddState?.pdpSddData;
  const shouldShowErrorMessage = Boolean(sddState?.pdpSddDataError);
  const errorMessage = SiteSettings?.sddErrorMessage;

  useEffect(() => {
    if (selectedVariant && selectedVariant.sku) sddState.fetchSddDataPdp(selectedVariant);
    const disposeCustomerLocationChangeOnPdpReaction = reaction(
      () => [customerLocationState.sddZip, storeLocatorSidebarState.isOpen],
      () => {
        if (selectedVariant && selectedVariant.sku) sddState.fetchSddDataPdp(selectedVariant);
      }
    );

    return () => {
      disposeCustomerLocationChangeOnPdpReaction();
    };
  }, [selectedVariant]);

  const isSizeSelected = Boolean(sidebarPdpData?.userSelectedSize);

  const shouldShowDeliveryMessage = Boolean(customerLocationState?.sddZip) && !shouldShowErrorMessage;
  const isAvailableForDelivery = Boolean(sddData?.available);
  const deliveryTypeLowerCased = sddData?.sdd_type.toLowerCase();
  const deliveryCutoffTime = sddData?.cutoff_time;

  return shouldShowOmniPdpExperience ? (
    <SddOmniPdpMessagingView
      isSizeSelected={isSizeSelected}
      shouldShowDeliveryMessage={shouldShowDeliveryMessage}
      shouldShowErrorMessage={shouldShowErrorMessage}
      errorMessage={errorMessage}
      sidebarPdpData={sidebarPdpData}
      isAvailableForDelivery={isAvailableForDelivery}
      deliveryTypeLowerCased={deliveryTypeLowerCased}
    />
  ) : (
    <SddMessagingView
      isSizeSelected={isSizeSelected}
      shouldShowDeliveryMessage={shouldShowDeliveryMessage}
      shouldShowErrorMessage={shouldShowErrorMessage}
      errorMessage={errorMessage}
      sidebarPdpData={sidebarPdpData}
      isAvailableForDelivery={isAvailableForDelivery}
      deliveryTypeLowerCased={deliveryTypeLowerCased}
      deliveryCutoffTime={deliveryCutoffTime}
    />
  );
};

const SddMessagingView = ({
  isSizeSelected,
  shouldShowDeliveryMessage,
  shouldShowErrorMessage,
  errorMessage,
  sidebarPdpData,
  isAvailableForDelivery,
  deliveryTypeLowerCased,
  deliveryCutoffTime,
}: {
  isSizeSelected: boolean;
  shouldShowDeliveryMessage: boolean;
  shouldShowErrorMessage: boolean;
  errorMessage: string;
  sidebarPdpData: StoreLocatorSidebarPdpData | null;
  isAvailableForDelivery: boolean;
  deliveryTypeLowerCased?: string;
  deliveryCutoffTime?: string;
}) => {
  const deliveryMessage = isAvailableForDelivery
    ? deliveryTypeLowerCased === 'sameday_delivery'
      ? `Order by ${deliveryCutoffTime} for same day delivery to `
      : 'Eligible for next day delivery to '
    : `Not eligible for ${deliveryTypeLowerCased === 'nextday_delivery' ? 'next day' : 'same day'} delivery to `;

  return isSizeSelected ? (
    shouldShowDeliveryMessage ? (
      <div className="sdd-messaging-container">
        {deliveryMessage}
        <p
          className="sdd-postal-code-cta"
          onClick={() => {
            openStoreLocatorSidebar({ feature: 'sdd', pdpProps: sidebarPdpData || undefined, page: 'pdp' });
          }}
        >
          {customerLocationState.sddZip}
        </p>
      </div>
    ) : (
      <div>
        <div className="sdd-messaging-container sdd-pre-location-message">
          <StoreLocatorAction storeLocatorType="sdd" />
        </div>
        {shouldShowErrorMessage && <p className="sdd-messaging-no-results">{errorMessage}</p>}
      </div>
    )
  ) : (
    <div className="sdd-messaging-container sdd-pre-location-message">
      <p>Select a size to check eligibility for same day delivery</p>
    </div>
  );
};

SddMessaging = observer(SddMessaging);
export { SddMessaging };
